import * as React from 'react';

type NoteContextType = {
  inlineTitle?: string;
  isInline?: boolean;
};

export const NoteContext = React.createContext<NoteContextType>({});

export const useNoteContext = (): NoteContextType => {
  const context = React.useContext(NoteContext);
  const isTestEnvironment = process.env.NODE_ENV === 'test';

  if (!context && !isTestEnvironment) {
    throw new Error('You must use component within Note Context');
  }

  return context;
};
